import {Option} from "./Option";
import {OptionType} from "./constants/Option.type";

export class SearchFormUtil {
    static setAllCheckboxesToTrue(options: Option[]) {
        let falseCount = 0;

        options.forEach(option => {
            if (option.type !== OptionType.CHECK_LIST) {
                return;
            }

            option.value.forEach((isChecked: boolean) => {
                if (!isChecked) {
                    falseCount++;
                }
            });

            if (falseCount === option.value.length) {
                option.value = option.value.map(() => true);
            }
        });
    }
}